module.exports = __webpack_public_path__ + "img/wg.74f42223.jpg";